<template>
  <div
    tabindex="0"
    :class="{'q-card':true,'q-focus':qid===question.id, 'q-hidden':question.setting.visibility.hidden }"
    @click="questionSetting(question,index)"
  >
    <div class="q-box">
      <div class="q-content">
        <div class="q-title-wrap">
          <div class="q-index">
            <span>{{ index +1 }}</span>
            <span
              v-if="question.setting.required"
              class="required"
            >*</span>
          </div>
          <div
            :class="{'content-editable':true,'editable-focus':contentfocus}"
            tabindex="0"
            @focus.capture="contentfocus=true"
            @blur.capture="contentfocus=false"
          >
            <v-input
              v-model="question.title"
              class="q-title"
              placeholder="点击填写题目"
            ></v-input>
          </div>
          <div
            :class="{'content-editable':true,'editable-focus':descfocus}"
            tabindex="0"
            @focus.capture="descfocus=true"
            @blur.capture="descfocus=false"
          >
            <v-input
              v-model="question.description"
              class="q-desc"
              placeholder="点击填写题目描述"
            ></v-input>
          </div>
        </div>
        <div class="q-option-list">
          <!-- <component :is="'option-list'"  v-for="(item,index) in optionData" :key="index"></component> -->
          <draggable
            v-model="question.options"
            v-bind="{group:question ,animation:300}"
            @start="drag=true"
            @end="drag=false"
          >
            <option-item
              v-for="(item,index) in question.options"
              :key="index"
              :type="question"
              :option="item"
              :index="++index"
              @deleteOption="deleteOption"
              @settingOption="settingOption"
            ></option-item>
          </draggable>
        </div>
        <div
          v-if="question.type==='input'?false:qid===question.id"
          class="q-option-operate"
        >
          <a
            class="btn-text btn-add-single"
            @mousedown="addsingle"
          >
            <i class="fa fa-plus"></i>
            <span>添加单个选项</span>
          </a>
          <a
            ref="more"
            class="btn-text btn-add-more"
            @click="addmore($event)"
          >
            <i class="fa fa-navicon"></i>
            <span>批量添加选项</span>
          </a>
        </div>
        <div class="q-operate">
          <i
            v-show="qid===question.id"
            class="fa fa-trash fa-lg"
            @click="deleteQuestion"
          ></i>
          <span
            class="visible"
            @click="visibleToggle(question)"
          >
            <el-tooltip
              content="该题目处于隐藏状态，选中您设定的选项时，该题目才显示"
              placement="top"
            >
              <img
                v-if="question.setting.visibility.hidden"
                class="hidden"
                src="@/assets/images/survey/edit/ico-hidden.svg"
              >
            </el-tooltip>
            <el-tooltip
              content="您将一个题目设置为隐藏，需要为该题目设置显示逻辑"
              placement="top"
            >
              <img
                v-if="!question.setting.visibility.hidden && qid===question.id"
                class="hidden"
                src="@/assets/images/survey/edit/eye.svg"
              >
            </el-tooltip>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import OptionItem from "./option-item";
import VInput from "./v-input";
import uuid from "uuid";
import Draggable from "vuedraggable";
export default {
  props: {
    question: {
      type: Object,
      required: true,
      default: function() {
        return {};
      }
    },
    index: {
      type: Number,
      required: true,
      default: 0
    }
  },
  data() {
    return {
      drag: false,
      timestamp: Date.parse(new Date()),
      cardfocus: false,
      contentfocus: false,
      descfocus: false,
      optionData: [
        {
          id: "1",
          label: ""
        }
      ]
    };
  },
  computed: {
    // activeQuestion: {
    //   get: function() {
    //     return this.$store.state.survey.activeQuestion
    //   },
    //   set: function() {

    //   }
    // },
    qid: {
      get: function() {
        return this.$store.state.survey.activeQuestion.id;
      },
      set: function() {}
    }
  },
  methods: {
    questionSetting(question, index) {
      const data = {
        question: question,
        index: index
      };
      this.$emit("activeQue", data);
    },
    selectText(e) {
      if (document.selection) {
        let range = document.body.createTextRange();
        range.moveToElementText(e.currentTarget);
        range.select();
      } else if (window.getSelection) {
        let range = document.createRange();
        range.selectNodeContents(e.currentTarget);
        window.getSelection().removeAllRanges();
        window.getSelection().addRange(range);
      }
    },
    deleteQuestion() {
      this.$confirm("确认要删除吗？", "删除题目确认", {
        distinguishCancelAndClose: true,
        confirmButtonText: "确认",
        cancelButtonText: "取消"
      }).then(() => {
        this.$store.dispatch("delQuestion", this.index);
        this.$store.dispatch("setActiveQuestion", {});
      });
    },
    addsingle() {
      const data = {
        id: this.question.id,
        option: [
          {
            id: uuid(this.timestamp),
            text: "",
            setting: {
              show: false,
              text: "",
              required: true,
              validate: ""
            }
          }
        ]
      };
      this.$store.dispatch("addOption", data);
    },
    addmore(e) {
      const left =
        this.getElementLeft(e.currentTarget) + e.currentTarget.offsetWidth + 10;
      const top = this.getElementTop(e.currentTarget);
      const lt = {
        left: left,
        top: top
      };
      this.$emit("addmore", lt);
    },
    getElementLeft(element) {
      var actualLeft = element.offsetLeft;
      var current = element.offsetParent;

      while (current !== null) {
        actualLeft += current.offsetLeft;
        current = current.offsetParent;
      }

      return actualLeft;
    },
    getElementTop(element) {
      var actualTop = element.offsetTop;
      var current = element.offsetParent;

      while (current !== null) {
        actualTop += current.offsetTop;
        current = current.offsetParent;
      }

      return actualTop;
    },
    settingOption(option) {
      this.$store.dispatch("setActiveOption", option);
      this.$store.dispatch(
        "setActiveOptionIndex",
        this.question.options.indexOf(option)
      );
    },
    deleteOption(qid, oid) {
      const data = {
        qindex: this.index,
        qid: qid,
        oid: oid
      };
      this.$store.dispatch("delOption", data);
    },
    // 切换题目隐藏还是显示
    visibleToggle(question) {
      question.setting.visibility.hidden = !question.setting.visibility.hidden;
    }
  },
  components: {
    OptionItem,
    VInput,
    Draggable
    // Bubble
  }
};
</script>
<style lang="less" scoped>
@import "./question-card.less";
</style>
